import styled, { css } from 'styled-components';
import { SkeletonLoader as _SkeletonLoader } from '@/components/SkeletonLoader/SkeletonLoader';
import { Typography } from '@/components/UI/Typography/Typography.styles';

export const SkeletonLoader = styled(_SkeletonLoader).attrs<{
  $isCount?: boolean;
}>(({ $isCount }) => ({
  height: $isCount ? 133 : 140,
  borderRadius: 24,
}))<{ $isTotal?: boolean; $isCount?: boolean }>`
  @media (max-width: ${({ theme }) => theme.breakpoints.md}) {
    height: ${({ $isTotal }) => ($isTotal ? 89 : 106)}px;
    border-radius: 21px;
  }
`;

export const Card = styled.div<{
  $isTotal?: boolean;
  $isCount?: boolean;
  $isInModal?: boolean;
}>`
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  gap: ${({ $isTotal }) => ($isTotal ? 0 : 10)}px;
  min-height: ${({ $isCount }) => ($isCount ? 133 : 140)}px;
  padding: 20px;
  border-radius: 24px;
  background-color: ${({ theme, $isTotal }) =>
    $isTotal
      ? theme.palette.primary.background
      : theme.palette.secondary.background};

  ${({ $isTotal, theme }) =>
    $isTotal &&
    css`
      border: 1px solid ${theme.palette.tertiary.labels};
    `}

  @media (max-width: ${({ theme }) => theme.breakpoints.md}) {
    min-height: ${({ $isTotal }) => ($isTotal ? 89 : 106)}px;
    border-radius: 21px;
  }

  ${({ $isInModal }) =>
    $isInModal &&
    css`
      @media (min-width: ${({ theme }) => theme.breakpoints.md}) {
        min-height: 89px;
        border-radius: 21px;
      }
    `}
`;

export const Header = styled.div<{ $isInModal?: boolean }>`
  display: flex;
  align-items: center;
  justify-content: space-between;

  @media (min-width: ${({ theme }) => theme.breakpoints.md}) {
    ${({ $isInModal }) =>
      !$isInModal &&
      css`
        flex-direction: column;
        align-items: flex-start;
        gap: 6px;
      `}
  }
`;

export const Title = styled(Typography.Body)<{ $isInModal?: boolean }>`
  @media (min-width: ${({ theme }) => theme.breakpoints.md}) {
    ${({ $isInModal }) =>
      !$isInModal &&
      css`
        font-size: 16px;
      `}
  }
`;

export const Amount = styled(Typography.Header).attrs({ $variant: '2' })<{
  $isCount?: boolean;
  $isInModal?: boolean;
}>`
  @media (min-width: ${({ theme }) => theme.breakpoints.md}) {
    ${({ $isCount, $isInModal }) =>
      !$isInModal &&
      css`
        font-size: ${$isCount ? 24 : 22}px;
      `}
  }
`;

export const Subtitle = styled(Typography.Caption).attrs({ $variant: '2' })<{
  $isInModal?: boolean;
}>`
  @media (min-width: ${({ theme }) => theme.breakpoints.md}) {
    ${({ $isInModal }) =>
      !$isInModal &&
      css`
        font-size: 12px;
      `}
  }
`;
